module.exports = __webpack_public_path__ + "img/icon-research.e33eeec9.svg";